import EditSmsContainer from "../../../../component/master-settings/sms-gateway/EditSmsContainer"

 
function EditSmsDetails() {
  return (
    <div className='page-body'>

    <EditSmsContainer/>
       
    </div>
  )
}

export default EditSmsDetails
